module.exports = __webpack_public_path__ + "static/media/adela.a4548157.jpg";